<div class="row mt-4" *ngIf="orcamento">
    <div class="col-sm-4 border-start border-primary">

        <!-- <h5 class="font-size-15 mb-3">Totais:</h5> -->

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Total Equipe X Despesas Produção</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.totalEquipeXDespesaProducao | currency:'BRL':'symbol':'1.2-2' }}</p>
            
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Total Geral Dos Custos</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.totalGeralCustos | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Variação De Orçamento</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.valorVariacaoOrcamento | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Total Material + Produção + Execução</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.totalMatProdExecReajuste | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Imposto Fatura Isento Iss</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.totalImpostoFaturaIsento | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

    </div>
    <div class="col-sm-4 border-start border-primary">


        <!-- <h5 class="font-size-15">Margem de custos:</h5> -->

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Custo Operacional</h5>
            <p class="text-muted mb-0 font-size-14"><span class="font-size-12">{{orcamento.percentualCustoOperacional}}% |</span> 
                {{ orcamento.totalCustoOperacional | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Margem De Lucro</h5>
            <p class="text-muted mb-0 font-size-14"><span class="font-size-12">{{orcamento.percentualMargemDeLucro}}% |</span>
                {{ orcamento.totalMargemDeLucro | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Comissão Vendas</h5>
            <p class="text-muted mb-0 font-size-14"><span class="font-size-12">{{orcamento.percentualComissaoVendas}}% |</span>
                {{ orcamento.totalComissaoVenda | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Comissão Studio/Arquiteto</h5>
            <p class="text-muted mb-0 font-size-14"><span class="font-size-12">{{orcamento.percentualStudioArquiteto}}% |</span>
                {{ orcamento.totalStudioArquiteto | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Margem Negociação</h5>
            <p class="text-muted mb-0 font-size-14"><span class="font-size-12">{{orcamento.percentualMargemNegociacao}}% |</span>
                {{ orcamento.totalMargemNegociacao | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>


    </div>
    <div class="col-sm-4 border-start border-primary">

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Valor M² Materiais</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.valorMMateriais | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Valor M² Produção</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.valorMProducao | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Valor M² Material + Produção</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.valorMMaterialEProducao | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>

        <div class="mt-2">
            <h5 class="font-size-16 mb-1">Valor M² Valor De Venda Final</h5>
            <p class="text-muted mb-0 font-size-14">{{ orcamento.valorMValorVendaFinal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
        </div>


    </div>
</div>
<hr>
<div class="row" *ngIf="orcamento">
    <div class="float-end ms-2">
        <h5 class="font-size-24">Valor Final:
            <span class="badge rounded-pill bg-success-subtle text-success font-size-22 fw-medium">{{orcamento.totalVenda | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </h5>
    </div>
</div>
<div *ngIf="!orcamento" class="text-center p-4">
    <p class="text-muted">Carregando totais do orçamento...</p>
</div>